import React from 'react';

import BatchPageTemplate from "./BatchPageTemplate";
import BatchLogDialog from "../cores/BatchLogDialog";

export default function BatchLogPage() {
  return <BatchPageTemplate
    batch_type="log"
    dialog={<BatchLogDialog />}
  />;
}
